// extracted by mini-css-extract-plugin
export var arrow = "announcementBanner-module--arrow--2fc17";
export var bannerBtnClose = "announcementBanner-module--bannerBtnClose--436c8";
export var bannerWrap = "announcementBanner-module--banner-wrap--a069c";
export var headline = "announcementBanner-module--headline--bdace";
export var link = "announcementBanner-module--link--6b08e";